import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _asyncToGenerator from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _defineProperty from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import _regeneratorRuntime from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.number.parse-int.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.number.parse-float.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RequestService from "../services/RequestService";
import AppFullscreen from 'quasar/src/plugins/AppFullscreen.js';;
import { mapMutations } from "vuex";
import { env } from "../config/env";
import Loading from 'quasar/src/plugins/Loading.js';;
import EditStyleComponent from "../components/edit-style-component.vue";
import ReconnectingWebSocket from "reconnecting-websocket";
import YouTubePlayer from "../components/youtube-iframe-api.vue";
import Notify from 'quasar/src/plugins/Notify.js';;
import LogService from "../services/LogService";
import CollectableLogsService from "src/services/CollectableLogsService";
var DEFAULT = "Padrão";
require("howler");
var loading = function loading(message) {
  if (!Loading.isActive) {
    return Loading.show({
      message: message,
      backgroundColor: "white",
      customClass: "loading-class",
      spinnerColor: "primary",
      messageColor: "black"
    });
  }
};
export default {
  components: {
    EditStyleComponent: EditStyleComponent,
    YouTubePlayer: YouTubePlayer
  },
  name: "PageIndexOld",
  data: function data() {
    return {
      collectedLogs: [],
      startedToCollectLogs: false,
      clienteId: 0,
      midiaConfig: {
        id: "",
        panelTextActive: false,
        soundPanel: "",
        volume: 0,
        volumeBeep: 0,
        timeToReturnVideo: 0,
        timeToSpeak: 0,
        activateVideo: false,
        painelId: "",
        panelVoice: ""
      },
      painel: {
        id: "",
        panelName: "",
        panelChannel: "",
        panelText: "",
        codeCallingText: "",
        nameCallingText: "",
        primaryColor: "",
        secondaryColor: "",
        clienteId: 0,
        footerTextSize: 12,
        configStylesPainel: {
          id: undefined,
          clienteId: "",
          containerPainelNameHeader: "",
          fullDateHeader: "",
          hourHeader: "",
          patientAndLocalLabelMain: "",
          containerPatientAndLocalCall: "",
          containerPatientAndLocalCallPrioritary: "",
          hourHistory: "",
          containerLastCallHistory: "",
          containerPatientAndCodeCallHistory: {
            color: "inherit",
            fontSize: "inherit"
          },
          footer: "",
          primaryColor: "",
          secondaryColor: "",
          prioritaryColor: {
            color: "inherit",
            fontSize: "inherit"
          }
        }
      },
      exibirChamado: false,
      isFetchingConfigStyle: false,
      podeExibirNovoChamado: true,
      chamado: {
        id: 1,
        isCalledByName: true,
        texto: "",
        local: "",
        code: "",
        data: new Date()
      },
      // fila de chamadas
      filaChamadas: [],
      filaChamadasIntervalRef: null,
      historico: [],
      ajustFontSizes: "",
      isReconnectingDialogOpened: false,
      synth: window.speechSynthesis,
      ws: null,
      stompClient: null,
      connected: false,
      channel: "",
      // abaixo é dedicado ao player de video
      playingIntervalRef: null,
      videoReapearing: null,
      muted: false,
      isPlaying: false,
      loop: false,
      requestService: new RequestService(),
      collectableLogsService: new CollectableLogsService(),
      videoIndex: 0,
      sources: [{}],
      currentVideo: {},
      allSources: [{}],
      options: {
        type: Object,
        default: function _default() {
          return {};
        }
      },
      isCreated: false,
      sendLogsInterval: null,
      verifyLoggingInterval: null
    };
  },
  methods: _objectSpread(_objectSpread({}, mapMutations("vuex_module", ["setTitle"])), {}, {
    getPatientHistoryLabel: function getPatientHistoryLabel(patient) {
      if (patient !== undefined) {
        if (patient.priority) {
          return "priority-bg";
        } else {
          return "";
        }
      }
      return "";
    },
    limitNumberPatients: function limitNumberPatients(historicList) {
      if (window.outerHeight < 1393) {
        return historicList.slice(0, 4);
      } else {
        return historicList.slice(0, 5);
      }
    },
    getCustomColor: function getCustomColor(isActive) {
      var headerDiv = document.querySelector(".q-card__section--vert");
      var footerDiv = document.querySelector(".panel-text-content");
      var footerP = document.querySelector(".panel-text-content p");
      var logoDiv = document.querySelector(".logo-contratante");
      var titleDiv = document.querySelector(".container-title");
      var titleP = document.querySelector(".container-title > p");
      var historyDiv = document.querySelector(".history");
      var fullDateHeader = document.querySelectorAll("#day-date > p");
      var timeHeader = document.querySelector("#time p");
      if (isActive) {
        if (this.painel.configStylesPainel && this.painel.configStylesPainel.primaryColor.color && this.painel.configStylesPainel.secondaryColor.color) {
          headerDiv.setAttribute("style", "background-color: ".concat(this.painel.configStylesPainel.secondaryColor.color, " !important;"));
          fullDateHeader[0].setAttribute("style", this.bindingStyles("fullDateHeader"));
          fullDateHeader[1].setAttribute("style", this.bindingStyles("fullDateHeader"));
          timeHeader.setAttribute("style", this.bindingStyles("timeHeader"));
          footerDiv.setAttribute("style", this.bindingStyles("styleFooter"));
          footerP.setAttribute("style", this.bindingStyles("styleFooter"));
          logoDiv.setAttribute("style", "background-color: ".concat(this.painel.configStylesPainel.secondaryColor.color, " !important;"));
          titleDiv.setAttribute("style", this.bindingStyles("styleHeader"));
          titleP.setAttribute("style", this.bindingStyles("styleHeader"));
          historyDiv.setAttribute("style", "background-color: ".concat(this.painel.configStylesPainel.primaryColor.color, " !important;"));
        }
      } else {
        headerDiv === null || headerDiv === void 0 ? void 0 : headerDiv.setAttribute("style", "background-color: #ebebeb !important");
        logoDiv === null || logoDiv === void 0 ? void 0 : logoDiv.setAttribute("style", "background-color: #ebebeb !important");
        titleDiv === null || titleDiv === void 0 ? void 0 : titleDiv.setAttribute("style", "background-color: rgb(235, 235, 235); color: black; box-shadow: none;");
      }
      Loading === null || Loading === void 0 ? void 0 : Loading.hide();
    },
    fullScreenOn: function fullScreenOn() {
      AppFullscreen.request();
    },
    fullScreenOff: function fullScreenOff() {
      AppFullscreen.exit();
    },
    disconnectWs: function disconnectWs() {
      try {
        if (this.ws) {
          this.ws.close();
        }
      } catch (error) {
        LogService.save('error', 'WEBSOCKET', 'Erro ao desconectar WebSocket:', error);
      }
    },
    disconnect: function disconnect() {
      this.stompClient.deactivate();
    },
    callingStyle: function callingStyle() {
      if (this.chamado.priority == true) {
        return "patient-calling-time patient-priority";
      } else {
        return "invisible";
      }
    },
    historyStyle: function historyStyle(priority) {
      if (priority == true) {
        return "patient-priority";
      } else {
        return "";
      }
    },
    initializeWs: function initializeWs() {
      var _this = this;
      if (this.ws) {
        this.ws.close();
      }
      var options = {
        WebSocket: WebSocket,
        // custom WebSocket constructor
        maxReconnectionDelay: 30000,
        minUptime: 5000,
        connectionTimeout: 30000,
        maxRetries: Infinity,
        maxEnqueuedMessages: Infinity,
        startClosed: false,
        debug: false
      };
      var token = encodeURIComponent(localStorage.getItem("painel-web-auth-token"));
      var wsUrl = "".concat(env.brokerUrl, "?channel=").concat(this.channel).concat(this.clienteId, "&token=").concat(token);
      this.ws = new ReconnectingWebSocket(wsUrl, [], options);
      this.ws.onmessage = function (event) {
        var data = JSON.parse(event.data);
        clearTimeout(_this.videoReapearing);
        if (_this.midiaConfig.activateVideo == true) {
          _this.turnVideoOff();
        }
        _this.filaChamadas.unshift(data);
      };
      this.ws.onopen = function (event) {
        //  
      };
      this.ws.onclose = function (event) {
        // 
      };
      this.ws.onerror = function (event) {
        try {
          LogService.save('error', 'WEBSOCKET', 'Erro na conexão WebSocket:', event);
        } catch (error) {
          LogService.save('error', 'WEBSOCKET', 'Erro no handler onerror:', error);
        }
      };
    },
    turnVideoOff: function turnVideoOff() {
      this.muted = true;
    },
    turnVideoOn: function turnVideoOn() {
      this.muted = false;
    },
    tryReconect: function tryReconect() {
      var _this2 = this;
      try {
        setTimeout(function () {
          try {
            _this2.initializeWs();
          } catch (error) {
            LogService.save('error', 'WEBSOCKET', 'Erro ao tentar reconectar:', error);
          }
        }, 5000);
      } catch (error) {
        LogService.save('error', 'WEBSOCKET', 'Erro no tryReconect:', error);
      }
    },
    chamaTexto: function chamaTexto() {
      var _this3 = this;
      var text = this.chamado.textBase.replace("#place", this.painel.placeName);
      if (this.midiaConfig.panelVoice !== DEFAULT) {
        this.speak(this.midiaConfig.panelVoice, text);
      } else {
        var greetingSpeech = new SpeechSynthesisUtterance();
        greetingSpeech.text = text;
        greetingSpeech.voice = this.synth.getVoices().find(function (voice) {
          return voice.lang == "pt-BR";
        });
        this.synth.speak(greetingSpeech);
        greetingSpeech.onend = function () {
          _this3.podeExibirNovoChamado = true;
          _this3.exibirVideo();
        };
      }
    },
    delay: function delay(ms) {
      return new Promise(function (resolve) {
        return setTimeout(resolve, ms);
      });
    },
    exibirVideo: function exibirVideo() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!_this4.midiaConfig.activateVideo) {
                _context.next = 5;
                break;
              }
              _context.next = 3;
              return _this4.delay(_this4.midiaConfig.timeToReturnVideo * 1000);
            case 3:
              _this4.exibirChamado = false;
              _this4.muted = false;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    speak: function speak(voice, text) {
      var _this5 = this;
      var self = this;
      var callback = function callback() {
        self.podeExibirNovoChamado = true;
        self.exibirVideo();
      };
      this.requestService.speak(voice, text).then(function (_ref) {
        var data = _ref.data;
        new Howl({
          src: "data:audio/mp3;base64,".concat(data),
          autoplay: true,
          onend: callback,
          onplayerror: callback,
          onloaderror: callback
        });
      }).catch(function (e) {
        console.log(e);
        _this5.createNotify("negative", e.message);
      });
    },
    setTexto: function setTexto(code, local, isCalledByName) {
      var textBase = isCalledByName ? this.painel.nameCallingText : this.painel.codeCallingText;
      if (!textBase) {
        textBase = isCalledByName[0] ? "#name compareça à #local" : "#name compareça ao guichê #local";
      }
      textBase = textBase.replace("#name", code);
      textBase = textBase.replace("#code", code);
      textBase = textBase.replace("#local", local);
      textBase = textBase.replace("#stand", local);
      return textBase;
    },
    criarChamado: function criarChamado(chamada) {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var genericStringCallingIdentifier, genericLocal, isCalledByName, priority, MAX_SIZE_HISTORIC, callDateTime, chamado;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              genericStringCallingIdentifier = chamada.genericStringCallingIdentifier, genericLocal = chamada.genericLocal, isCalledByName = chamada.isCalledByName, priority = chamada.priority;
              if (!chamada.isMessage) _this6.playSound();
              MAX_SIZE_HISTORIC = 6;
              callDateTime = new Date();
              chamado = {
                id: callDateTime.toISOString(),
                isCalledByName: isCalledByName,
                local: isCalledByName ? genericLocal : _this6.painel.placeName + " " + genericLocal,
                code: !isCalledByName ? "Senha " + genericStringCallingIdentifier : genericStringCallingIdentifier,
                priority: priority,
                textBase: chamada.isMessage ? "".concat(chamada.firstLineMessage, " ").concat(chamada.secondLineMessage) : _this6.setTexto(genericStringCallingIdentifier, genericLocal, isCalledByName),
                isMessage: chamada.isMessage,
                firstLineMessage: chamada.firstLineMessage,
                secondLineMessage: chamada.secondLineMessage,
                data: callDateTime.getDate().toLocaleString("pt-BR", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit"
                }),
                time: _this6.formatTime(callDateTime)
              };
              _this6.chamado = chamado;
              if (!chamada.isMessage) {
                _this6.historico.unshift(chamado);
                if (_this6.historico.length > MAX_SIZE_HISTORIC) {
                  _this6.historico.pop();
                }
              }
              _this6.exibirChamado = true;
              new Promise(function (resolve, reject) {
                setTimeout(function () {
                  resolve();
                }, _this6.midiaConfig.timeToSpeak * 1000);
              }).then(function () {
                if (chamada.withVoice) {
                  _this6.chamaTexto();
                } else {
                  _this6.podeExibirNovoChamado = true;
                }
              });
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    limitCharacters: function limitCharacters(nome) {
      var receivedName = nome.split(" ");
      if (receivedName.length > 3) {
        if (nome.length > 27) {
          nome = "".concat(receivedName[0].length > 15 ? receivedName[0].slice(0, 15) + "." : receivedName[0], " ").concat(receivedName[1][0].toUpperCase(), ". ").concat(receivedName[2][0].toUpperCase(), ". ").concat(receivedName[receivedName.length - 1].length > 15 ? receivedName[receivedName.length - 1].slice(0, 15) + "." : receivedName[receivedName.length - 1]);
        } else {
          nome = "".concat(receivedName[0], " ").concat(receivedName[1][0], " ").concat(receivedName[2]);
        }
      }
      return nome;
    },
    limitarTamanhoNomePaciente: function limitarTamanhoNomePaciente(namePatient, type) {
      var temPatient = namePatient.split(" ");
      var finalName = temPatient[0];
      if (temPatient.length >= 3) {
        for (var i = 1; i < temPatient.length; i++) {
          if (i == temPatient.length - 1) {
            finalName += " ".concat(temPatient[i]);
          } else {
            finalName += " ".concat(temPatient[i].charAt(0).toUpperCase(), ".");
          }
        }
      } else {
        return namePatient;
      }
      return finalName;
    },
    formatTime: function formatTime(currentTime) {
      var hours = currentTime.getHours().toLocaleString("pt-BR", {
        minimumIntegerDigits: 2,
        useGrouping: false
      });
      var minutes = currentTime.getMinutes().toLocaleString("pr-BR", {
        minimumIntegerDigits: 2,
        useGrouping: false
      });
      return "".concat(hours, ":").concat(minutes);
    },
    sendLogsIfEnabled: function sendLogsIfEnabled() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (_this7.sendLogsInterval) clearInterval(_this7.sendLogsInterval);
              _this7.sendLogsInterval = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                var _yield$_this7$request, data;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.prev = 0;
                      _context3.next = 3;
                      return _this7.requestService.shouldCollectFrontendLogs(_this7.clienteId);
                    case 3:
                      _yield$_this7$request = _context3.sent;
                      data = _yield$_this7$request.data;
                      if (!data) {
                        _context3.next = 8;
                        break;
                      }
                      _context3.next = 8;
                      return _this7.collectableLogsService.sendLogs(_this7.collectedLogs);
                    case 8:
                      _this7.collectedLogs = [];
                      _context3.next = 14;
                      break;
                    case 11:
                      _context3.prev = 11;
                      _context3.t0 = _context3["catch"](0);
                      console.error("Erro ao verificar shouldCollectFrontendLogs / sendLogs:", _context3.t0);
                    case 14:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3, null, [[0, 11]]);
              })), 300000);
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    verifyIfCanEnableFrontendLogging: function verifyIfCanEnableFrontendLogging() {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var tryStartLogging;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              tryStartLogging = /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                  var _yield$_this8$request, data;
                  return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.prev = 0;
                        _context5.next = 3;
                        return _this8.requestService.shouldCollectFrontendLogs(_this8.clienteId);
                      case 3:
                        _yield$_this8$request = _context5.sent;
                        data = _yield$_this8$request.data;
                        if (data) {
                          _this8.collectableLogsService.startCollectingLogs(_this8.collectedLogs);
                          _this8.startedToCollectLogs = true;
                        }
                        _context5.next = 11;
                        break;
                      case 8:
                        _context5.prev = 8;
                        _context5.t0 = _context5["catch"](0);
                        console.error("Erro ao verificar shouldCollectFrontendLogs / startCollectingLogs:", _context5.t0);
                      case 11:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5, null, [[0, 8]]);
                }));
                return function tryStartLogging() {
                  return _ref3.apply(this, arguments);
                };
              }();
              _context7.next = 3;
              return tryStartLogging();
            case 3:
              if (_this8.verifyLoggingInterval) clearInterval(_this8.verifyLoggingInterval);
              _this8.verifyLoggingInterval = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      if (!_this8.startedToCollectLogs) {
                        _context6.next = 2;
                        break;
                      }
                      return _context6.abrupt("return");
                    case 2:
                      _context6.prev = 2;
                      _context6.next = 5;
                      return tryStartLogging();
                    case 5:
                      _context6.next = 10;
                      break;
                    case 7:
                      _context6.prev = 7;
                      _context6.t0 = _context6["catch"](2);
                      console.error("Erro ao startCollectingLogs:", _context6.t0);
                    case 10:
                    case "end":
                      return _context6.stop();
                  }
                }, _callee6, null, [[2, 7]]);
              })), 250000);
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    getPanelByChannel: function getPanelByChannel() {
      var _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var _yield$_this9$request, data, _i, _Object$keys, key;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!_this9.isCreated) {
                _context8.next = 20;
                break;
              }
              loading("<h5>Carregando painel</h5>...");
              _context8.prev = 2;
              _context8.next = 5;
              return _this9.requestService.findPanelByChannel(_this9.clienteId, _this9.channel);
            case 5:
              _yield$_this9$request = _context8.sent;
              data = _yield$_this9$request.data;
              _this9.painel = data;
              _this9.setTitle(_this9.painel.panelName);
              _this9.getMidiaConfig(_this9.painel.id);
              if (_this9.painel.configStylesPainel) {
                for (_i = 0, _Object$keys = Object.keys(_this9.painel.configStylesPainel); _i < _Object$keys.length; _i++) {
                  key = _Object$keys[_i];
                  if (_this9.painel.configStylesPainel[key] && _this9.painel.configStylesPainel[key].includes("{")) {
                    _this9.painel.configStylesPainel[key] = JSON.parse(_this9.painel.configStylesPainel[key]);
                  }
                }
              }
              _this9.getCustomColor(true);
              Loading.hide();
              _context8.next = 20;
              break;
            case 15:
              _context8.prev = 15;
              _context8.t0 = _context8["catch"](2);
              Loading.hide();
              console.log(_context8.t0);
              _this9.createNotify("negative", _context8.t0.message);
            case 20:
            case "end":
              return _context8.stop();
          }
        }, _callee8, null, [[2, 15]]);
      }))();
    },
    createNotify: function createNotify(type, message) {
      Notify.create({
        color: type,
        type: type,
        textColor: "white",
        message: message,
        position: "top"
      });
    },
    playSound: function playSound() {
      var sound = new Howl({
        src: "statics/sons/" + this.midiaConfig.soundPanel,
        autoplay: true,
        volume: this.midiaConfig.volumeBeep,
        onend: function onend() {}
      });
      sound.play();
    },
    getMidiaConfig: function getMidiaConfig(painelId) {
      var _this10 = this;
      this.requestService.getMidiaConfig(painelId).then(function (_ref5) {
        var data = _ref5.data;
        _this10.midiaConfig = data;
        if (_this10.midiaConfig.activateVideo === true) {
          _this10.getVideos();
        } else {
          _this10.turnVideoOff();
        }
        _this10.textAnimation();
      }).catch(function (err) {
        console.log(err);
        _this10.createNotify("negative", err.message);
      });
    },
    setCurrentVideo: function setCurrentVideo(video) {
      if (video.origin == "local") {
        var mapper = {
          src: video.key,
          type: "video/mp4"
        };
        var sour = [mapper];
        this.sources = sour;
      }
      this.currentVideo = video;
    },
    getVideos: function getVideos() {
      var _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var videos;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return _this11.requestService.getAllVideos(_this11.clienteId);
            case 2:
              videos = _context9.sent;
              if (videos.length == 0) {
                _this11.turnVideoOff();
              } else {
                _this11.allSources = videos;
                _this11.setCurrentVideo(_this11.allSources[0]);
              }
            case 4:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    onPlayerEnded: function onPlayerEnded() {
      this.nextVideo();
    },
    nextVideo: function nextVideo() {
      if (this.allSources.length - 1 == this.videoIndex) {
        this.videoIndex = 0;
      } else {
        this.videoIndex = this.videoIndex + 1;
      }
      this.setCurrentVideo(this.allSources[this.videoIndex]);
    },
    textAnimation: function textAnimation() {
      var textAnim = document.querySelector(".text-info");
      var p = document.querySelector(".text-info p");
      var refDiv = document.querySelector("#panel-text-content");
      if (this.midiaConfig.panelTextActive) {
        setInterval(function () {
          if (Number.parseInt(textAnim.style.right) < p.offsetWidth) {
            textAnim.style.right = Number.parseFloat(textAnim.style.right) + 1 + "px";
          } else {
            textAnim.style.right = -Number.parseFloat(refDiv.offsetWidth) + "px";
          }
        }, 100);
      } else {
        //textAnim.classList.add()
        p.style.whiteSpace = "normal";
      }
    },
    bindingStyles: function bindingStyles(element) {
      var _this12 = this;
      if (!this.painel.configStylesPainel) return;
      if (this.painel.configStylesPainel.id === undefined && !this.isFetchingConfigStyle) {
        this.isFetchingConfigStyle = true;
        this.getPanelByChannel().then(function () {
          return _this12.isFetchingConfigStyle = false;
        });
      }
      if (!this.painel.configStylesPainel.patientAndLocalLabelMain) {
        this.painel.configStylesPainel.patientAndLocalLabelMain = {
          fontSize: "18px",
          color: "black",
          styleFont: "bold"
        };
      }
      if (!this.painel.configStylesPainel.containerPatientAndLocalCall) {
        this.painel.configStylesPainel.containerPatientAndLocalCall = {
          fontSize: "18px",
          color: "black",
          styleFont: "bold"
        };
      }
      if (!this.painel.configStylesPainel.primaryColor) {
        this.painel.configStylesPainel.primaryColor = {
          color: "black"
        };
      }
      if (!this.painel.configStylesPainel.secondaryColor) {
        this.painel.configStylesPainel.secondaryColor = {
          color: "black"
        };
      }
      if (!this.painel.configStylesPainel.containerPainelNameHeader) {
        this.painel.configStylesPainel.containerPainelNameHeader = {
          fontSize: "18px",
          color: "black",
          styleFont: "bold"
        };
      }
      if (!this.painel.configStylesPainel.fullDateHeader) {
        this.painel.configStylesPainel.fullDateHeader = {
          fontSize: "18px",
          color: "black",
          styleFont: "bold"
        };
      }
      if (!this.painel.configStylesPainel.hourHeader) {
        this.painel.configStylesPainel.hourHeader = {
          fontSize: "18px",
          color: "black",
          styleFont: "bold"
        };
      }
      switch (element) {
        case "labelNameLocal":
          return "font-size: ".concat(this.painel.configStylesPainel.patientAndLocalLabelMain.fontSize, ";color: ").concat(this.painel.configStylesPainel.patientAndLocalLabelMain.color, ";font-weight: ").concat(this.painel.configStylesPainel.patientAndLocalLabelMain.styleFont, ";");
        case "containerCall":
          return "font-size: ".concat(this.painel.configStylesPainel.containerPatientAndLocalCall.fontSize, ";color: ").concat(this.painel.configStylesPainel.containerPatientAndLocalCall.color, ";font-weight: ").concat(this.painel.configStylesPainel.containerPatientAndLocalCall.styleFont, ";background-color:").concat(this.chamado.priority ? this.painel.configStylesPainel.prioritaryColor.color : this.painel.configStylesPainel.primaryColor.color, "!important;");
        case "styleHeader":
          return "background-color: ".concat(this.painel.configStylesPainel.primaryColor.color, " !important; font-size: ").concat(this.painel.configStylesPainel.containerPainelNameHeader.fontSize, " !important;color: ").concat(this.painel.configStylesPainel.containerPainelNameHeader.color, " !important;font-weight: ").concat(this.painel.configStylesPainel.containerPainelNameHeader.styleFont, " !important;");
        case "styleFooter":
          return "font-size: ".concat(this.painel.configStylesPainel.footer.fontSize, ";color: ").concat(this.painel.configStylesPainel.footer.color, ";font-weight: ").concat(this.painel.configStylesPainel.footer.styleFont, ";background-color:").concat(this.painel.configStylesPainel.secondaryColor.color, "!important;");
        case "fullDateHeader":
          return "font-size: ".concat(this.painel.configStylesPainel.fullDateHeader.fontSize, " !important;color: ").concat(this.painel.configStylesPainel.fullDateHeader.color, ";font-weight: ").concat(this.painel.configStylesPainel.fullDateHeader.styleFont, ";background-color:").concat(this.painel.configStylesPainel.secondaryColor.color, "!important;");
        case "timeHeader":
          return "font-size: ".concat(this.painel.configStylesPainel.hourHeader.fontSize, " !important;color: ").concat(this.painel.configStylesPainel.hourHeader.color, ";font-weight: ").concat(this.painel.configStylesPainel.hourHeader.styleFont, ";background-color:").concat(this.painel.configStylesPainel.secondaryColor.color, "!important;");
        default:
          break;
      }
    }
  }),
  mounted: function mounted() {
    var _this13 = this;
    if (this.isCreated) {
      window.addEventListener("offline", function () {
        try {
          _this13.connected = false;
          _this13.isReconnectingDialogOpened = true;
          _this13.tryReconect();
        } catch (error) {
          LogService.save('error', 'WEBSOCKET', 'Erro no evento offline:', error);
        }
      });

      // window.addEventListener("online-youtube", () => {
      //   try {
      //     window.dispatchEvent(new Event("youtube-play-video"));
      //   } catch (error) {
      //     LogService.save('error', 'WEBSOCKET', 'Erro no evento online:', error);
      //   }
      // });

      window.addEventListener("online", function () {
        _this13.connected = true;
        _this13.isReconnectingDialogOpened = false;
        _this13.tryReconect();
      });
      this.filaChamadasIntervalRef = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var chamada;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;
              if (!_this13.podeExibirNovoChamado) {
                _context10.next = 14;
                break;
              }
              chamada = _this13.filaChamadas.pop();
              if (!(chamada != null)) {
                _context10.next = 14;
                break;
              }
              _this13.podeExibirNovoChamado = false;
              _context10.prev = 5;
              _context10.next = 8;
              return _this13.criarChamado(chamada);
            case 8:
              _context10.next = 14;
              break;
            case 10:
              _context10.prev = 10;
              _context10.t0 = _context10["catch"](5);
              _this13.podeExibirNovoChamado = true;
              LogService.save('error', 'WEBSOCKET', 'Erro ao criar chamado:', _context10.t0);
            case 14:
              _context10.next = 19;
              break;
            case 16:
              _context10.prev = 16;
              _context10.t1 = _context10["catch"](0);
              LogService.save('error', 'WEBSOCKET', 'Erro no interval da fila:', _context10.t1);
            case 19:
            case "end":
              return _context10.stop();
          }
        }, _callee10, null, [[0, 16], [5, 10]]);
      })), 200);
      this.playingIntervalRef = setInterval(function () {
        try {
          if (_this13.currentVideo && _this13.currentVideo.origin === 'local' && _this13.$refs.qmp) {
            _this13.$refs.qmp.play();
          } else if (_this13.currentVideo && _this13.currentVideo.origin === 'youtube') {
            window.dispatchEvent(new Event("youtube-play-video"));
          }
        } catch (e) {
          console.error("Erro ao tentar reproduzir vídeo:", e);
        }
      }, 2000);
      this.$root.$on("updatePainelStyle", function () {
        _this13.getPanelByChannel();
      });
      this.verifyIfCanEnableFrontendLogging();
      this.sendLogsIfEnabled();
    }
  },
  updated: function updated() {
    //  this.getCustomColor(true);
  },
  created: function created() {
    try {
      this.clienteId = this.$route.params.cliente;
      if (!this.requestService.revalidarToken(this.clienteId)) {
        this.$router.replace("/");
      } else {
        this.isCreated = true;
        this.$root.$emit("btnInteraction");
        this.channel = this.$route.params.channel;
        this.initializeWs();
        this.getPanelByChannel();
      }
    } catch (error) {
      LogService.save('error', 'PAINEL_LIFECYCLE', 'Erro no created:', error);
    }
  },
  beforeUnmount: function beforeUnmount() {
    try {
      if (this.isCreated) {
        this.disconnectWs();
      }
    } catch (error) {
      LogService.save('error', 'PAINEL_LIFECYCLE', 'Erro no beforeUnmount:', error);
    }
  },
  beforeDestroy: function beforeDestroy() {
    try {
      if (this.isCreated) {
        this.getCustomColor(false);
        if (this.playingIntervalRef) clearInterval(this.playingIntervalRef);
        if (this.filaChamadasIntervalRef) clearInterval(this.filaChamadasIntervalRef);
        if (this.sendLogsInterval) clearInterval(this.sendLogsInterval);
        if (this.verifyLoggingInterval) clearInterval(this.verifyLoggingInterval);
      }
    } catch (error) {
      LogService.save('error', 'PAINEL_LIFECYCLE', 'Erro no beforeDestroy:', error);
    }
  }
};